import { handleActions } from "redux-actions";

import { PayloadAction, combineReducers } from "@reduxjs/toolkit";
import { INIT_DATA_LISTS, GosInitListsType } from "../config";
import { SPDataType, Status } from "../types";

import {
  getGosInitData,
  getGosInitDataSuccess,
  getGosInitDataFailure,
  getGosInitDataIdle,
} from "../actions";




export type DynamicType = {
  [key in GosInitListsType]: SPDataType[] | [];
};

type DefaultInitDataType = {
  status: Status;
  data: DynamicType;
};

const defaultStateInitDataLists = INIT_DATA_LISTS.reduce((acc, key) => {
  acc[key] = [];
  return acc;
}, {} as Record<GosInitListsType, SPDataType[] | []>);

const defaultState: DefaultInitDataType = {
  data: defaultStateInitDataLists,
  status: "IDLE",
};

const data = handleActions(
  {
    [getGosInitDataSuccess as any]: (
      state: DynamicType,
      action: PayloadAction<DynamicType>
    ) => {
      return { ...state, ...action.payload };
    },
  },
  defaultState.data
);

const initDataStatus = handleActions(
  {
    [getGosInitDataSuccess as any]: () => "SUCCESS",
    [getGosInitData as any]: () => "LOADING",
    [getGosInitDataFailure as any]: () => "FAILURE",
    [getGosInitDataIdle as any]: () => "IDLE",
  },
  defaultState.status
);

const initData = combineReducers({
  status: initDataStatus,
  data,
});
const gos = combineReducers({
  initData,
});

export { gos };
